import * as actions from './signup/actions'
import * as mutations from './signup/mutations'
import * as getters from './signup/getters'

import { signupProps } from './signup/properties'

const state = {
    props: JSON.parse(JSON.stringify(signupProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/signup.js